import Head from 'next/head';

function generateOaiqPixelScript(pixelId: string, debug: boolean) {
  return `
  !function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");
  oaiq("init",{pixelId:"${pixelId}",debug:${debug}});
  `;
}

const OaiqPixel: React.FC<{ readonly pixelId: string }> = ({ pixelId }) => {
  return (
    <Head>
      <script
        key="oaiq-pixel"
        dangerouslySetInnerHTML={{
          __html: generateOaiqPixelScript(
            pixelId,
            process.env.NODE_ENV !== 'production',
          ),
        }}
      ></script>
    </Head>
  );
};

export default OaiqPixel;
